import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { SidebarChildItem, SidebarMenuItem } from './sidebarMenu';


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarMenuItem',
  props: {
    item: null,
    expanded: { type: Boolean },
    collapsed: { type: Boolean },
    activeRoute: null
  },
  emits: ["toggle", "navigate"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'toggle', name: string): void;
    (e: 'navigate', item: SidebarMenuItem | SidebarChildItem): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    item: SidebarMenuItem;
    expanded: boolean;
    collapsed: boolean;
    activeRoute?: string;
};





const hasChildren = computed(() => !!props.item.children?.length);
const visibleChildren = computed(() => props.item.children?.filter((child) => !child.hidden) ?? []);

const getHref = (item: SidebarMenuItem | SidebarChildItem) => item.href || item.route;
const isExternal = (item: SidebarMenuItem | SidebarChildItem) => !!item.href;

const isLink = computed(() => !hasChildren.value && !!getHref(props.item));

// ctrl/cmd/shift/alt + click or a non-primary button (e.g. wheel click): let the browser
// handle the anchor natively so the route opens in a new tab/window.
const isModifiedClick = (event: MouseEvent) =>
    event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0;

const handleClick = (item: SidebarMenuItem | SidebarChildItem, event: MouseEvent) => {
    if (getHref(item) && (isModifiedClick(event) || isExternal(item))) {
        return;
    }
    event.stopPropagation();
    event.preventDefault();
    emit('navigate', item);
};

const onItemClick = (event: MouseEvent) => {
    if (hasChildren.value) {
        event.stopPropagation();
        event.preventDefault();
        emit('toggle', props.item.name);
        return;
    }
    handleClick(props.item, event);
};

return { __sfc: true,props, emit, hasChildren, visibleChildren, getHref, isExternal, isLink, isModifiedClick, handleClick, onItemClick }
}

})